import { apiMipe } from '@/core/api/';

const URL = 'api/appointment';

export const saveTabSections = (clientAppointmentId, data) =>
  apiMipe.put(`api/appointment/${clientAppointmentId}/savetab`, data);

export const getTabSections = (clientAppointmentId, tabIdx) =>
  apiMipe.get(`api/appointment/tab/${clientAppointmentId}/${tabIdx}`);

export const getAppointmentInterventionRecommendation = (clientAppointmentId) =>
  apiMipe.get(`${URL}/interventionrecommendation/${clientAppointmentId}`);

export const saveNoInterventionRecommendation = (clientAppointmentId, params) =>
  apiMipe.post(
    `${URL}/nointerventionrecommendation/save/${clientAppointmentId}`,
    params
  );

export const saveInterventionRecommendation = (clientAppointmentId, params) =>
  apiMipe.post(
    `${URL}/interventionrecommendation/save/${clientAppointmentId}`,
    params
  );

export const getAppointmentForTabI = (clientAppointmentId) =>
  apiMipe.get(`${URL}/tabI/${clientAppointmentId}`);

export const saveAppointmentTabI = (params) =>
  apiMipe.post(`${URL}/savetabI`, params);

export const getAppointmentAreaWithGoalsAndObjectives = (clientAppointmentId) =>
  apiMipe.get(`${URL}/area/${clientAppointmentId}`);

export const saveAppointmentAreaWithGoalsAndObjectives = (
  clientAppointmentId,
  params
) => apiMipe.post(`${URL}/saveAppointmentArea/${clientAppointmentId}`, params);

export const saveAppointmentSpecialistSignature = (
  clientAppointmentId,
  params
) =>
  apiMipe.post(
    `${URL}/specialistsignature/save/${clientAppointmentId}`,
    params
  );

export const getAppointmentSpecialistSignature = (clientAppointmentId) =>
  apiMipe.get(`${URL}/specialistsignature/${clientAppointmentId}`);

export const getGoalListsByUser = () => apiMipe.get(`${URL}/goalsbyuser`);

export const getObjectiveListsByUser = () =>
  apiMipe.get(`${URL}/objectivesbyuser`);

export const submitAppointmentTabs = (clientAppointmentId) =>
  apiMipe.post(`${URL}/submitTabs/${clientAppointmentId}`);

export const saveSpaceCoordination = (params) =>
  apiMipe.post(`${URL}/spacecoordination`, params);

export const getAppointmentRecord = (clientAppointmentId) => {
  return apiMipe.get(`${URL}/${clientAppointmentId}/record`);
};
